import PropTypes from 'prop-types';

const CveResolution = ({ value }) => (<span dangerouslySetInnerHTML={{ __html: value }}/>);

CveResolution.propTypes = {
    value: PropTypes.string
};

export default CveResolution;
